import React from 'react';
import DetailPageMainView from './DetailPageMainView';
import StandardRelativeView from './StandardRelativeView';
import ApprovalList from '../Approval/ApprovalList';
import { CodeSplit } from 'code-split-component';
import classNames from 'classnames';
import LazyLoad from '../LazyLoad/LazyLoad';
import { AccItem, Loading } from '@beisen/chaos-ui';
import { ExtensionWrap } from '../util/extension';
import * as helper from '../util/helper';
import * as ui from '../util/ui';
require('./onepage.css');
const isInLeve3 = window.env.platform.weixin || window.env.platform.dingTalk;

class StandardOnePage extends React.Component {
    constructor(props,context) {
        super(props,context);
        this.scrollHandler = this.scrollHandler.bind(this);
        this.touchTapHandler = this.touchTapHandler.bind(this);
        this.removeTabFun = this.removeTabFun.bind(this);
        this.state = {
            activeItem: null,
            hideOnepageFeedIn: true // 初始隐藏feed输入框
        };
        this.showFeedIn = false; // 初始隐藏feed输入框
        this.isOnlyFeed = this.props.tabLabArr && this.props.tabLabArr.length == 1 && this.props.tabLabArr[0].key == 'feed';
        this.isExpand = false;
        this.initHeight = 0;
        this.isTouchScroll = false;
        this.point = 0;
        this.onePageTabHeight = 40;
        this.moduleHeightObjArr = [];
        this.deviceNavHeight = window.env.platform.android ? 69 : 64;//ios64 android69
        this.deviceHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    }

    componentDidMount() {
        this.getModuleInfo();
        const last = this.moduleHeightObjArr[this.moduleHeightObjArr.length - 1];
        this.initHeight = last ? last['y'] + last['height'] + this.deviceNavHeight + this.onePageTabHeight : 0;
        this.removeTabFun();
        this.shouldShowFeedIn() && this.setState({ hideOnepageFeedIn: false }) && (this.showFeedIn = true); // 首次加载判断是否要显示输入框
        // if (window.env.platform.bsAppIOS) {
        //     window.env.on(
        //         {
        //             name: 'viewappear'
        //         },
        //         () => {
        //             helper.pageReload()
        //         }
        //     );
        // }
    }

    componentDidUpdate() {
        if(this.isExpand) {
            this.isExpand = false;
        }
        this.setFeedIn();
    }

    setFeedInShow() {
        if(!this.showFeedIn) {
            this.state.hideOnepageFeedIn && this.setState({ hideOnepageFeedIn: false });
            this.showFeedIn = true;
            this.feedInDOM.style.transform = 'translateY(0px)';
            this.feedInDOM.style.WebkitTransform = 'translateY(0px)';
        }
    }

    setFeedInHide() {
        if(this.showFeedIn) {
            this.showFeedIn = false;
            this.feedInDOM.style.transform = `translateY(${this.feedInHeight}px)`;
            this.feedInDOM.style.WebkitTransform = `translateY(${this.feedInHeight}px)`;
        }
    }

    setFeedInDOM() {
        if(!this.feedInDOM) {
            this.feedInDOM = document.getElementsByClassName('onepageFeedIn')[0];
        }
    }

    setFeedInHeight() {
        if(!this.feedInHeight) {
            this.setFeedInDOM();
            this.feedInHeight = this.feedInDOM ? this.feedInDOM.offsetHeight : 0;
        }
    }

    shouldShowFeedIn() {
        if(this.props.isShowButtonList) return false;
        const top = this.refs.feedView && this.refs.feedView.getBoundingClientRect().top || 0;
        this.setFeedInHeight();
        return top + 100  < this.deviceHeight;
    }

    setFeedIn() {
        // 注意：只有页面没有按钮时才按此规则展示feed输入框
        if(!this.props.isShowButtonList) {
            this.setFeedInHeight();
            if(this.feedInDOM) {
                this.shouldShowFeedIn() ? this.setFeedInShow() : this.setFeedInHide();
            }
        }
    }

    getModuleInfo() {
        this.moduleHeightObjArr = [];
        this.props.tabLabArr.forEach(item => {
            let y = 0;
            let height = 0;
            //40 => tab的高度
            let tabHeight = this.refs.onepagetabcopy ? this.refs.onepagetabcopy.offsetHeight : 40;
            let onePageTabHeight = isInLeve3 || window.env.platform.beisenApp ? tabHeight + (isInLeve3 && this.props.hasRightIcon ? 40 : 0) : tabHeight + 40;
            switch(item.key) {
                case 'detail':
                y = this.refs.mainView.offsetTop - onePageTabHeight;
                height = this.refs.mainView.offsetHeight;
                break;
                case 'relative':
                y = this.refs.relativeView.offsetTop - onePageTabHeight;
                height = this.refs.relativeView.offsetHeight;
                break;
                case 'approval':
                y = this.refs.approveView.offsetTop - onePageTabHeight;
                height = this.refs.approveView.offsetHeight;
                break;
                case 'feed':
                y = this.refs.feedView.offsetTop - onePageTabHeight;
                height = this.refs.feedView.offsetHeight;
                break;
                default :
                    y = this.refs.mainView.offsetTop - onePageTabHeight;
                    height = this.refs.mainView.offsetHeight;
            }
            this.moduleHeightObjArr.push({ name: item.value, y: y, height: height });
        });
    }

    removeTabFun() {
        const onepagetabnode = document.getElementById('onpagetab');
        const onepagetabcopynode = document.getElementById('onepagetab-copy');
        if(onepagetabcopynode && this.deviceHeight >= this.initHeight) {
            onepagetabnode && document.getElementsByClassName('onepage')[0] && document.getElementsByClassName('onepage')[0].removeChild(onepagetabnode);
            onepagetabcopynode && document.getElementsByClassName('onepage_content')[0] && document.getElementsByClassName('onepage_content')[0].removeChild(onepagetabcopynode);
        }
    }

    scrollHandler(e) {
        this.setFeedIn();
        const before = this.point <= 0 ? null : this.moduleHeightObjArr[this.point - 1];
        const active = this.moduleHeightObjArr[this.point];
        const next = this.point >= this.moduleHeightObjArr.length ? null : this.moduleHeightObjArr[this.point + 1];
        const scrollHeight = e.target.scrollTop;
        const scrollElement = document.getElementById('scrollPage');
        if(!this.isTouchScroll) {
            this.getModuleInfo();
        }
        if(next && scrollHeight >= next.y) {
            if(next) {
                this.point++;
                this.props.changeTabActiveStyle && this.props.changeTabActiveStyle(this.point);
            }
        }else if(active && scrollHeight < active.y && !this.isTouchScroll) {
            if(before) {
                this.point--;
                this.props.changeTabActiveStyle && this.props.changeTabActiveStyle(this.point);
            }
        }

        if(ui.isScrollStop(scrollElement)) {
            this.isTouchScroll = false;
        }
    }

    touchTapHandler(index) {
        this.isTouchScroll = true;
        this.point = index;
        const scrollElement = document.getElementById('scrollPage');
        this.getModuleInfo();
        scrollElement.scrollTop = this.moduleHeightObjArr[index]['y'];
    }

    renderMainView(mainViewData) {
        if(!mainViewData.cmp_data.visible) {
            return null;
        }
        const content = (
            <ExtensionWrap {...mainViewData} componentMap={this.props.componentMap}>
                <DetailPageMainView {...mainViewData} componentMap={this.props.componentMap} formType={'detailForm'} />
            </ExtensionWrap>
        );

        if(!mainViewData.cmp_data.accordion) {
            return <div ref='mainView' className='onepage-main'>{content}</div>;
        }

        return (
            <div ref='mainView' className='onepage-main'>
              <AccItem showDetail={!mainViewData.cmp_data.active} disableClose={mainViewData.cmp_data.disableClose} title={mainViewData.cmp_data && mainViewData.cmp_data.title || '详情'}>
                {content}
              </AccItem>
            </div>
        );
    }

    relativeTouchMore(item) {
        this.props.handlerRelativeJump(null,item);
    }

    handlerAccrodionClick(item) {
        this.isExpand = true;
        this.setState({ activeItem: item.cmp_id });
        this.props.getWidgetHtmlHeight && this.props.getWidgetHtmlHeight();
    }

    isRelativeViewActived(item) {
        return this.state.activeItem === item.cmp_id || item.cmp_data.disableColse || item.cmp_data.active;
    }

    renderRelativeView() {
        // accitem 边框颜色取值范围
        const borderColors = ['#ff7360', '#ff9500', '#ffc300', '#8bda44', '#00e099', '#4dd0e1', '8a92ff'];
        const colorsNums = borderColors.length;
        let childArr = [];
        for(let index = 0; index < this.props.onePageData.relativeViewData.length; index++) {
            const item = this.props.onePageData.relativeViewData[index];
            const isRelativeActived = this.isRelativeViewActived(item);
            if(!item.cmp_data.visible) {
                continue;
            }
            childArr.push(
                <AccItem borderColor={borderColors[index % colorsNums]}
                        partCode={item.cmp_data.viewName}
                        accItemIndex={index}
                        showDetail={!isRelativeActived}
                        disableClose={item.cmp_data.active && item.cmp_data.disableClose || item.cmp_data.isPlugin}
                        title={item.cmp_data && item.cmp_data.title || '相关'}
                        key={item.cmp_id}
                        onTouchExpand={this.handlerAccrodionClick.bind(this,item)}
                        onTouchMore={this.relativeTouchMore.bind(this,item)}
                        >

                   <LazyLoad show={isRelativeActived} accItemIndex={index}>
                        <div className='onepage_table_list'>
                            <StandardRelativeView
                                query={helper.getQueryObject()}
                                detailPage={this.props.detailPage}
                                {...item}
                                accItemIndex={index}
                                actions={this.props.actions}
                                onTouchMore={this.relativeTouchMore.bind(this,item)}
                                getWidgetHtmlHeight={this.props.getWidgetHtmlHeight}
                                translation={this.props.translation}
                            />
                        </div>
                    </LazyLoad>
                </AccItem>
            );
        }
        return childArr;
    }

    renderApprovalProcess() {
        const queryObj = helper.getQueryObject();
        if(queryObj.processInstanceId) {
            return (
                <div ref='approveView' style={{ position: 'relative', 'minHeight': '100px' }}>
                    <ApprovalList processInstanceId={queryObj.processInstanceId} style={{ paddingTop: '8px' }} showTip={this.props.actions.showTip} />
                </div>
            );
        }
        return null;
    }

    getFeedId(feedData) {
        const query = this.props.query;
        if(query._feedId) {
            return query._feedId;
        }

        if(feedData && feedData.sub_cmps && feedData.sub_cmps[0]) {
            return feedData.sub_cmps[0]['cmp_id'];
        }
    }

    getOnepageFooter() {
        let feedIn = document.getElementsByClassName('onepagefooter')[0];
        if(!feedIn) {
            this.getOnepageFooter();
        }
        return feedIn;
    }

    feedSwitchTabHandler(activekey) {
        if(!this.props.isShowButtonList) {
            if(activekey == '1') {// feed问题： 1.切换到操作记录时 没有执行此回调  2.切换到操作记录时 直接将输入框dom移除了 因此此处需要重新获取
                this.feedInDOM = document.getElementsByClassName('onepageFeedIn')[0];
                this.feedInHeight = this.feedInDOM ? this.feedInDOM.offsetHeight : 0;
            }
            return;
        }
        let footerButton = document.getElementsByClassName('transition-wrap-detail')[0];
        if(footerButton && footerButton.style.transform == 'translateY(0px)') {
		    const transY = footerButton && footerButton.offsetHeight || 55;
            footerButton.style.transform = `translateY(${transY}px)`;
            footerButton.style.WebkitTransform = `translateY(${transY}px)`;
        }
        let feedIn = this.getOnepageFooter();
        if(feedIn && activekey == '1') {
            feedIn.style.opacity = 1;
            feedIn.style.zIndex = 2;
        }
    }
    //获取feed相关数据
    renderFeed(feedId, title) {
        if(!feedId) {
            return null;
        }
        const feedHeight = this.deviceHeight - (this.props.tabLabArr.length == 1 ? 8 : this.onePageTabHeight) - (this.props.isShowButtonList ? 58 : 0);
        return (
            <div ref='feedView' style={{ 'paddingTop': '4px', position: 'relative', 'height': feedHeight + 'px' }}>
                <CodeSplit chunkName="TitaFeed" modules={{ TitaFeed: require('@pbeisen/tita-feed') }} defer={false}>
                   {
                       function render(modules) {
                            const TitaFeed = modules.TitaFeed;
                            return modules.TitaFeed && modules.TitaFeed.SimpleFeed ? <modules.TitaFeed.SimpleFeed hideOperation={this.props.hideOperationRecord}  feedId={feedId} feedSwitchTabHandler={this.feedSwitchTabHandler.bind(this)} footercls={classNames('onepageFeedIn',{ 'onepagefooter': !this.isOnlyFeed && this.props.isShowButtonList },{ 'hideOnepageFeedIn': this.state.hideOnepageFeedIn && !this.props.isShowButtonList })} contentHeight={feedHeight - 40} /> : <Loading />;
                       }.bind(this)
                   }
                </CodeSplit>
            </div>);
    }

    renderTabCopy() {
        return <div ref='onepagetabcopy' id='onepagetab-copy' className={classNames('onepagetab-copy',{ 'display-none': !this.props.isShowTab })} style={{ height: '40px' }}></div>;
    }


    renderRelativeViewTpl(relativeView,isMain) {
        const containerRef = isMain ? '' : 'relativeView';
        return(
            <div ref={containerRef}>
                <div className='accordion'>
                    {relativeView}
                </div>
            </div>
        );
    }

    render() {
        let mainView = this.renderMainView(this.props.onePageData.mainViewData);
        let relativeView = this.renderRelativeView();
        let approveView = this.renderApprovalProcess();
        let feedView = this.renderFeed(this.getFeedId(this.props.onePageData.feedData));

        const isMainViewInAccrodion = this.props.onePageData &&
        this.props.onePageData.mainViewData && this.props.onePageData.mainViewData.cmp_data.accordion;

        const relativeViewDataLength = this.props.onePageData && this.props.onePageData.relativeViewData && this.props.onePageData.relativeViewData.length || 0;

        return (
          <div className={classNames('onepage_content',{ 'all-hide': isMainViewInAccrodion })}>
              {this.renderTabCopy()}
              {!isMainViewInAccrodion ?  mainView : this.renderRelativeViewTpl(mainView,isMainViewInAccrodion)}
              {relativeViewDataLength > 0 ? this.renderRelativeViewTpl(relativeView) : null}
              {approveView}
              {feedView}
          </div>
        );
    }
}
export default StandardOnePage;



// WEBPACK FOOTER //
// ./src/components/DetailPage/StandardOnePage.js